module.exports = __webpack_public_path__ + "img/team_before_btn.fd7ea0a4.png";